import React from "react";
import PropTypes from "prop-types";
import {
  IconButton,
  Popover,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { useSelector } from "react-redux";

function FavoritePopover({
  open,
  onClosePopover,
  anchorEl,
  handleOpenMenuNameDialog,
  fooditem,
  handleMenuDelete,
  handleOpenMenuDeleteDialog,
  handleCloseMenuDeleteDialog,
  deleteMenuName,
  handleAddItemToExistingMenu,
}) {
  const { selectedMenus = [] } = useSelector(
    (state) => state.menus,
  );
  console.log("selected menus", selectedMenus);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Popover
        anchorEl={anchorEl}
        open={open}
        onClose={onClosePopover}
        disableRestoreFocus
        PaperProps={{
          sx: {
            width: {
              xs: "35vw",
              sm: 170,
              md: 200,
            },

            borderRadius: 2,
            overflow: "hidden",
          },
        }}
        anchorOrigin={{
          vertical: isMobile ? "bottom" : "bottom",
          horizontal: isMobile ? "center" : "left",
        }}
        transformOrigin={{
          vertical: isMobile ? "left" : "left",
          horizontal: isMobile ? "left" : "left",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            p: { xs: 0, sm: 2 },
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              // gap: 0.5,
              // mb: 1,
            }}
          >
            <IconButton
              onClick={handleOpenMenuNameDialog}
              size={isMobile ? "large" : "medium"}
            >
              <AddIcon />
            </IconButton>
            <Typography
              className="responsive_fontsize18"
              variant={isMobile ? "subtitle1" : "h6"}
              fontWeight={400}
            >
              Make Your Menu!
            </Typography>
          </Box>

          {/* Menu List */}
          <List
            dense={isMobile}
            sx={{
              overflowY: "auto",
              maxHeight: { xs: "15vh", sm: "auto" },
            }}
          >
            {selectedMenus.map((menu) => (
              <ListItem
                className="responsive_fontsize16"
                key={menu.menu_id}
                button
                onClick={() => {
                  if (!fooditem) return;
                  handleAddItemToExistingMenu(menu.menuName, fooditem);
                }}
                sx={{
                  borderRadius: 1,
                  "&:hover": {
                    backgroundColor: "action.hover",
                  },
                }}
              >
                <ListItemText
                  primary={menu.menuName}
                  primaryTypographyProps={{
                    noWrap: true,
                  }}
                />
                <ListItemSecondaryAction>
                  <IconButton
                    edge="end"
                    size="small"
                    onClick={(event) => {
                      event.stopPropagation();
                      handleOpenMenuDeleteDialog(menu.menuName, menu.menu_id);
                    }}
                  >
                    <DeleteIcon fontSize="inherit" />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </Box>
      </Popover>

    </>
  );
}

FavoritePopover.propTypes = {
  open: PropTypes.bool.isRequired,
  onClosePopover: PropTypes.func.isRequired,
  anchorEl: PropTypes.object,
  handleOpenMenuNameDialog: PropTypes.func.isRequired,
  fooditem: PropTypes.object.isRequired,
  handleMenuDelete: PropTypes.func.isRequired,
  handleOpenMenuDeleteDialog: PropTypes.func.isRequired,
  handleCloseMenuDeleteDialog: PropTypes.func.isRequired,
  deleteMenuName: PropTypes.string,
};

FavoritePopover.defaultProps = {
  anchorEl: null,
  deleteMenuName: "",
};

export default FavoritePopover;
